"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
require("./sis-time-picker.component.css");
var DATE_INPUT_VALUE_ACCESSOR = {
    provide: forms_1.NG_VALUE_ACCESSOR,
    useExisting: core_1.forwardRef(function () { return TimePickerComponent; }),
    multi: true
};
var TimePickerComponent = /** @class */ (function () {
    function TimePickerComponent(changeDetectorRef) {
        this.changeDetectorRef = changeDetectorRef;
        /**
         * Time unit
         */
        this.AM = "AM";
        /**
         * Time unit
         */
        this.PM = "PM";
        this._dialogIsHoursVisible = false;
        this._dialogIsMinutesVisible = false;
        this._dialogIsPeriodVisible = false;
        this._dialogTimes = [];
        this._inputIsFocused = false;
        this._isNewTimePassedFromNgModel = false;
        this._isDefaultTimeEmitted = false;
        this._is12HourClockSystem = true;
        this._isTimeSelectedFromMenu = false;
        this._12HourClockSystemPattern = /^([1-9]|0[1-9]|1[0-2]):([0-5][0-9]) ([AP]M)$/;
        this._24HourClockSystemPattern = /^([0-9]|0[0-9]|1[0-9]|2[0-3]):([0-5][0-9])$/;
    }
    Object.defineProperty(TimePickerComponent.prototype, "clockSystemPattern", {
        set: function (pattern) {
            var isPreviousClockSystem12Hour = this._is12HourClockSystem;
            this._is12HourClockSystem = pattern.toUpperCase().includes("A");
            if (isPreviousClockSystem12Hour !== this._is12HourClockSystem && (this._isNewTimePassedFromNgModel || this._isDefaultTimeEmitted)) {
                this.changeClockSystem();
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * SetTimeout needs because writeValue method with new passed time angular calls after ngAfterViewInit and
     * components emits default time.
     */
    TimePickerComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (this.hour == undefined || this.minute == undefined || (this._is12HourClockSystem && this.period == undefined)) {
            if (this._is12HourClockSystem) {
                this.initDialogTimesFor12HourClockSystem();
                this._hour = this._previousHour = "12";
                this._minute = this._previousMinute = "00";
                this._period = this._previousPeriod = this.AM;
            }
            else {
                this.initDialogTimesFor24HourClockSystem();
                this._hour = this._previousHour = "00";
                this._minute = this._previousMinute = "00";
            }
            setTimeout(function () {
                _this.emitDefaultTimeIfNeeds();
            });
            this.changeDetectorRef.detectChanges();
        }
    };
    TimePickerComponent.prototype.changeClockSystem = function () {
        if (this._is12HourClockSystem) {
            this.to12HourClockSystem();
            this.initDialogTimesFor12HourClockSystem();
        }
        else {
            this.to24HourClockSystem();
            this.initDialogTimesFor24HourClockSystem();
        }
        if (this._hour.length === 1) {
            this._hour = "0" + this._hour;
        }
        this._onChangeCallback(this.getTime());
    };
    TimePickerComponent.prototype.to12HourClockSystem = function () {
        if (+this._hour > 12) {
            this._period = this.PM;
            this._hour = "" + (+this.hour - 12);
        }
        else if (this._hour === "12") {
            this._period = this.PM;
        }
        else if (this._hour === "00") {
            this._period = this.AM;
            this._hour = "12";
        }
        else {
            this._period = this.AM;
        }
    };
    TimePickerComponent.prototype.to24HourClockSystem = function () {
        if (this.period === this.AM) {
            if (this._hour === "12") {
                this._hour = "00";
            }
        }
        else if (+this._hour < 12) {
            this._hour = "" + (+this.hour + 12);
        }
    };
    TimePickerComponent.prototype.initDialogTimesFor12HourClockSystem = function () {
        this._dialogTimes = [];
        this.initDialogTimesFor12HourClockSystemByPeriod(this.AM);
        this.initDialogTimesFor12HourClockSystemByPeriod(this.PM);
    };
    TimePickerComponent.prototype.initDialogTimesFor12HourClockSystemByPeriod = function (period) {
        this._dialogTimes.push("12:00 " + period);
        this._dialogTimes.push("12:30 " + period);
        for (var i = 1; i < 10; i++) {
            this._dialogTimes.push("0" + i + ":00 " + period);
            this._dialogTimes.push("0" + i + ":30 " + period);
        }
        this._dialogTimes.push("10:00 " + period);
        this._dialogTimes.push("10:30 " + period);
        this._dialogTimes.push("11:00 " + period);
        this._dialogTimes.push("11:30 " + period);
    };
    TimePickerComponent.prototype.initDialogTimesFor24HourClockSystem = function () {
        this._dialogTimes = [];
        for (var i = 0; i < 10; i++) {
            this._dialogTimes.push("0" + i + ":00");
            this._dialogTimes.push("0" + i + ":30");
        }
        for (var i = 10; i < 24; i++) {
            this._dialogTimes.push(i + ":00");
            this._dialogTimes.push(i + ":30");
        }
    };
    /**
     * if new time doesn't passed from ngModel need to emit default time.
     * Default time in 12 hour clock system was 12:00 AM and in 24 hour clock system was 00:00
     */
    TimePickerComponent.prototype.emitDefaultTimeIfNeeds = function () {
        if (!this._isNewTimePassedFromNgModel) {
            if (this._is12HourClockSystem) {
                if (this.getTime() === "12:00 AM") {
                    this._isDefaultTimeEmitted = true;
                    this._onChangeCallback("12:00 AM");
                }
            }
            else {
                if (this.getTime() === "00:00") {
                    this._isDefaultTimeEmitted = true;
                    this._onChangeCallback("00:00");
                }
            }
        }
    };
    /**
     * From ControlValueAccessor interface
     *
     * @override
     * @param {string} time - Time passed value from ngModel input in format "HH:MM" or "HH:MM A"
     */
    TimePickerComponent.prototype.writeValue = function (time) {
        this.initTimeValuesFromString(time);
    };
    /**
     * Initializes hour, minute and if clock hour system was 12 also period fields.
     *
     * @param {string} time - Time in format "HH:MM" or "HH:MM A"
     */
    TimePickerComponent.prototype.initTimeValuesFromString = function (time) {
        if (time != null) {
            var regExpMatchArray = this._is12HourClockSystem ? this._12HourClockSystemPattern.exec(time) : this._24HourClockSystemPattern.exec(time);
            if (regExpMatchArray !== null) {
                var hour = regExpMatchArray[1], minute = regExpMatchArray[2], period = regExpMatchArray[3];
                this._isNewTimePassedFromNgModel = true;
                this._hour = hour.length === 1 ? "0" + hour : hour;
                this._minute = minute;
                if (this._is12HourClockSystem) {
                    this._period = period;
                }
            }
        }
    };
    /**
     * From ControlValueAccessor interface
     *
     * @override
     * @param callbackFunction ngModelChange output callback
     */
    TimePickerComponent.prototype.registerOnChange = function (callbackFunction) {
        this._onChangeCallback = callbackFunction;
    };
    /**
     * From ControlValueAccessor interface
     *
     * @override
     */
    TimePickerComponent.prototype.registerOnTouched = function (callbackFunction) {
        this._onTouchedCallback = callbackFunction;
    };
    TimePickerComponent.prototype.incrementHour = function () {
        if (this._is12HourClockSystem) {
            this.incrementHourIn12HourClockSystem();
        }
        else {
            this.incrementHourIn24HourClockSystem();
        }
        this.generateTime();
    };
    TimePickerComponent.prototype.incrementHourIn12HourClockSystem = function () {
        switch (this._hour) {
            case "12":
                this._hour = "01";
                break;
            case "11":
                this._hour = "12";
                this.switchPeriod();
                break;
            default:
                this._hour = "" + (+this._hour + 1);
        }
    };
    TimePickerComponent.prototype.incrementHourIn24HourClockSystem = function () {
        this._hour = this._hour === "23" ? "00" : "" + (+this._hour + 1);
    };
    TimePickerComponent.prototype.decrementHour = function () {
        if (this._is12HourClockSystem) {
            this.decrementHourIn12HourClockSystem();
        }
        else {
            this.decrementHourIn24HourClockSystem();
        }
        this.generateTime();
    };
    TimePickerComponent.prototype.decrementHourIn12HourClockSystem = function () {
        switch (this._hour) {
            case "12":
                this._hour = "11";
                this.switchPeriod();
                break;
            case "01":
                this._hour = "12";
                break;
            default:
                this._hour = "" + (+this._hour - 1);
        }
    };
    TimePickerComponent.prototype.decrementHourIn24HourClockSystem = function () {
        this._hour = this._hour === "00" ? "23" : "" + (+this._hour - 1);
    };
    TimePickerComponent.prototype.onHourScroll = function (scrollEvent) {
        // We getting vertical scroll amount from detail, as deltaY property of wheel event isn't available in Mozilla.
        var verticalScrollAmount = scrollEvent.deltaY || scrollEvent.detail;
        var isScrolledUp = verticalScrollAmount < 0;
        if (isScrolledUp) {
            this.incrementHour();
        }
        else {
            this.decrementHour();
        }
    };
    TimePickerComponent.prototype.onHourChange = function (hour, hourElement) {
        if (hour !== this._hour) {
            if (this._is12HourClockSystem) {
                if (hour === "" || +hour === 0) {
                    this._hour = "";
                }
                else if (+hour > 0 && +hour < 13) {
                    this._hour = hour;
                }
                else {
                    this._hour = "12";
                }
            }
            else {
                if (hour === "") {
                    this._hour = "";
                }
                else if (+hour < 0) {
                    this._hour = "00";
                }
                else if (+hour > 23) {
                    this._hour = "23";
                }
                else {
                    this._hour = hour;
                }
            }
            hourElement.value = this._hour;
        }
    };
    TimePickerComponent.prototype.onMinuteScroll = function (scrollEvent) {
        // We getting vertical scroll amount from detail, as deltaY property of wheel event isn't available in Mozilla.
        var verticalScrollAmount = scrollEvent.deltaY || scrollEvent.detail;
        this.changeMinute(verticalScrollAmount < 0);
    };
    TimePickerComponent.prototype.changeMinute = function (isIncremented) {
        if (+this._minute === 0) {
            if (isIncremented) {
                this._minute = "01";
            }
            else {
                this._minute = "59";
                this.decrementHour();
            }
        }
        else if (+this._minute === 59) {
            if (isIncremented) {
                this._minute = "00";
                this.incrementHour();
            }
            else {
                this._minute = "58";
            }
        }
        else {
            this._minute = isIncremented ? "" + (+this._minute + 1) : "" + (+this._minute - 1);
            if (this._minute.length === 1) {
                this._minute = "0" + this._minute;
            }
        }
        this.generateTime();
    };
    TimePickerComponent.prototype.onMinuteChange = function (minute, minuteElement) {
        if (minute !== this._minute) {
            this._minute = minute === "" ? "" : +minute > -1 && +minute < 60 ? "" + minute : "59";
            minuteElement.value = this._minute;
        }
    };
    TimePickerComponent.prototype.onPeriodChange = function (period, periodElement) {
        if (period !== this._period) {
            period = period.toUpperCase();
            var isPeriod = period === this.AM || period === this.PM;
            this._period = isPeriod ? period : this.AM;
            periodElement.value = this._period;
        }
    };
    TimePickerComponent.prototype.switchPeriodWithGeneratingTime = function () {
        this.switchPeriod();
        this.generateTime();
    };
    TimePickerComponent.prototype.switchPeriod = function () {
        this._period = this._period === this.AM ? this.PM : this.AM;
    };
    TimePickerComponent.prototype.selectTime = function (time) {
        this._isTimeSelectedFromMenu = true;
        this.removeActiveClassFromTimeMenuList();
        this.initTimeValuesFromString(time);
        var generatedTime = this.getTime();
        this._onChangeCallback(generatedTime);
    };
    TimePickerComponent.prototype.onInputFocus = function (focusedElementType) {
        this._inputIsFocused = true;
        switch (focusedElementType) {
            case "hour":
                this._dialogIsHoursVisible = true;
                this._dialogIsMinutesVisible = false;
                this._dialogIsPeriodVisible = false;
                this._previousHour = this._hour;
                break;
            case "minute":
                this._dialogIsHoursVisible = false;
                this._dialogIsMinutesVisible = true;
                this._dialogIsPeriodVisible = false;
                this._previousMinute = this._minute;
                break;
            case "period":
                this._dialogIsHoursVisible = false;
                this._dialogIsMinutesVisible = false;
                this._dialogIsPeriodVisible = true;
                this._previousPeriod = this._period;
                break;
        }
    };
    TimePickerComponent.prototype.onInputFocusOut = function () {
        this._inputIsFocused = false;
        this._dialogIsHoursVisible = false;
        this._dialogIsMinutesVisible = false;
        this._dialogIsPeriodVisible = false;
        this.generateTime();
    };
    TimePickerComponent.prototype.generateTime = function () {
        if (this._hour === "") {
            this._hour = this._previousHour;
        }
        if (this._minute === "") {
            this._minute = this._previousMinute;
        }
        if (this._hour.length === 1) {
            this._hour = "0" + this._hour;
        }
        if (this._minute.length === 1) {
            this._minute = "0" + this._minute;
        }
        var generatedTime = this.getTime();
        this._onChangeCallback(generatedTime);
    };
    TimePickerComponent.prototype.getTime = function () {
        return this._is12HourClockSystem ? this._hour + ":" + this._minute + " " + this._period : this._hour + ":" + this._minute;
    };
    TimePickerComponent.prototype.onTimeMenuOpen = function () {
        var nativeElement = this.getTimeMenuElementByCurrentTime();
        nativeElement.focus();
        if (this._minute === "00" || this._minute === "30") {
            nativeElement.classList.add("ng-time-picker-menu__item--selected");
        }
    };
    TimePickerComponent.prototype.onTimeMenuClose = function () {
        if (!this._isTimeSelectedFromMenu) {
            this.removeActiveClassFromTimeMenuList();
        }
        else {
            this._isTimeSelectedFromMenu = false;
        }
    };
    TimePickerComponent.prototype.removeActiveClassFromTimeMenuList = function () {
        var nativeElement = this.getTimeMenuElementByCurrentTime();
        if (nativeElement !== null) {
            nativeElement.classList.remove("ng-time-picker-menu__item--selected");
        }
    };
    TimePickerComponent.prototype.getTimeMenuElementByCurrentTime = function () {
        var time = this.getRoundedTime();
        return this.timeMenuElements.find(function (elementRef) { return elementRef.nativeElement.innerText === time; }).nativeElement;
    };
    TimePickerComponent.prototype.getRoundedTime = function () {
        var time = this.getTime();
        if (this._minute !== "00" && this._minute !== "30") {
            var searchText = ":" + this._minute;
            var replaceValue = void 0;
            if (+this._minute < 16) {
                replaceValue = ":00";
            }
            else if (+this._minute > 45) {
                var newHour = this._hour === "23" ? this._hour : "" + (+this._hour + 1);
                if (newHour.length === 1) {
                    newHour = "0" + newHour;
                }
                searchText = this._hour + ":" + this._minute;
                replaceValue = newHour + ":00";
            }
            else {
                replaceValue = ":30";
            }
            time = time.replace(searchText, replaceValue);
        }
        return time;
    };
    Object.defineProperty(TimePickerComponent.prototype, "hour", {
        get: function () {
            return this._hour;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TimePickerComponent.prototype, "minute", {
        get: function () {
            return this._minute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TimePickerComponent.prototype, "period", {
        get: function () {
            return this._period;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TimePickerComponent.prototype, "dialogIsHoursVisible", {
        get: function () {
            return this._dialogIsHoursVisible;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TimePickerComponent.prototype, "dialogIsMinutesVisible", {
        get: function () {
            return this._dialogIsMinutesVisible;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TimePickerComponent.prototype, "dialogIsPeriodVisible", {
        get: function () {
            return this._dialogIsPeriodVisible;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TimePickerComponent.prototype, "dialogTimes", {
        get: function () {
            return this._dialogTimes;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TimePickerComponent.prototype, "inputIsFocused", {
        get: function () {
            return this._inputIsFocused;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TimePickerComponent.prototype, "is12HourClockSystem", {
        get: function () {
            return this._is12HourClockSystem;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], TimePickerComponent.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], TimePickerComponent.prototype, "clockSystemPattern", null);
    __decorate([
        core_1.ViewChildren("timeMenuElement"),
        __metadata("design:type", core_1.QueryList)
    ], TimePickerComponent.prototype, "timeMenuElements", void 0);
    TimePickerComponent = __decorate([
        core_1.Component({
            
            selector: "sis-time-picker",
            template: require('./sis-time-picker.component.html'),
            providers: [DATE_INPUT_VALUE_ACCESSOR]
        }),
        __metadata("design:paramtypes", [core_1.ChangeDetectorRef])
    ], TimePickerComponent);
    return TimePickerComponent;
}());
exports.TimePickerComponent = TimePickerComponent;
//# sourceMappingURL=sis-time-picker.component.js.map